// Library Imports
import axios from 'axios';

// Set up axios defaults
axios.defaults.baseURL = 'https://www.appriana.com';
axios.defaults.withCredentials = false;

export async function requestDemo (payload) {
   var f = await axios.post('/requestdemo', payload);
   return f;
}

export async function contact (payload) {
   var f = await axios.post('/contact', payload);
   return f;
}

export async function waitlist (payload) {
   var f = await axios.post('/bloom/waitlist', payload);
   return f;
}


// WEBPACK FOOTER //
// ./src/backend/site.js